<template>
  <div :class="`${rowClass} h-100`">
    <div :class="`${colClass} h-100`">
      <div :class="`card package ${!isOnlyImage ? 'h-100' : ''}`">
        <div v-if="!!imageUrl" class="text-center">
          <img :src="imageUrl" :alt="block.image_alt" :class="!isOnlyImage ? 'card-img-top' : 'card-img'" />
        </div>
        <div v-if="block.type == 'document-card'" class="text-center pt-3">
          <i class="fa fa-file-pdf display-4"></i>
        </div>
        <div v-if="!isOnlyImage" class="card-body">
          <div v-html="text"></div>
          <div v-if="!!buttonText && !!buttonUrl" class="text-center my-4">
            <b-button
              variant="branded"
              :href="buttonUrl"
              :target="buttonTarget || '_self'"
              :style="buttonStyle"
              @click="onClickButton"
            >
              {{ buttonText }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      block: Object,
    },
    computed: {
      buttonStyle() {
        if (!this.block.button_color) return null
        return `background-color: ${this.block.button_color}; border-color: ${this.block.button_color}`
      },
      text() {
        const placeholders = _.createPageBlockPlaceholders(this.block)
        return _.replacePlaceholders(this.block.text, placeholders)
      },
      buttonUrl() {
        if (this.block.type == 'staff-login-link') return '/login'
        let type = _.linkType(this.block.button_url, null, this.block.organization_id)
        let protocol = null
        if (type == 'email') protocol = 'mailto'
        else if (type == 'tel') protocol = 'tel'
        return _.compact([protocol, this.block.button_url]).join(':')
      },
      buttonText() {
        if (this.block.type == 'staff-login-link') return trans('login')
        if (!this.block.button_text && this.block.type == 'am-class-card') return trans('register')
        return this.block.button_text
      },
      buttonTarget() {
        if (this.block.type == 'staff-login-link') return '_blank'
        return this.block.button_target
      },
      imageUrl() {
        if (this.block.type == 'package-card') return this.block.package_image_url || null
        return this.block.image_url
      },
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        return this.block.span_row ? _.getColClass(this.block) : null
      },
      isOnlyImage() {
        return this.imageUrl && !this.text && !(this.buttonText && this.buttonUrl)
      },
    },
    methods: {
      onClickButton(e) {
        if (this.buttonTarget == 'popup') {
          e.preventDefault()
          if (this.block.type == 'am-class-card') {
            window.classRegisterAmClassId = this.block.am_class_id
            this.$bvModal.show('class-register-modal')
            return
          }
          window.formIframeModalUpid = _.extractUpidFromUrl(this.buttonUrl)
          this.$bvModal.show('form-iframe-modal')
        }
        this.$emit('click', e)
      },
    },
    mounted() {
      window['pageCardBlock_'+(this.block && this.block.id ? this.block.id : '')] = this
    },
  }
</script>